/** Cookie hint so SSR can skip marketing for returning logged-in users (Pinia token is localStorage-only). */
export const AUTH_SESSION_HINT_COOKIE = 'lip-has-session'

export function useAuthSessionHint() {
  return useCookie(AUTH_SESSION_HINT_COOKIE, {
    default: () => '',
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
    path: '/',
  })
}

export function syncAuthSessionHintCookie(token) {
  const hint = useAuthSessionHint()
  hint.value = token ? '1' : ''
}
